<h2 mat-dialog-title>{{ data.title }}</h2>
<div *ngIf="hasWarning()">
  <p class="warning">
    {{ data.warning }}
  </p>
</div>
<p>{{ data.description }}</p>
<mat-dialog-content>
  <das-user-autocomplete
    *ngFor="let assignment of data.assignableRoles"
    [users]="assignment.users"
    [role]="assignment.role"
    [initial]="currentUsers[assignment.role]"
    [required]="data.rolesRequired"
    [errorMessage]="'A user needs to be assigned to this role'"
    (selected)="selected($event, assignment)"
  ></das-user-autocomplete>

  <mat-form-field class="input">
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Add a comment"
      [formControl]="inputComment"
      [required]="data.commentRequired"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="cancel()">CANCEL</button>
  <button mat-raised-button color="primary" (click)="assign()" [disabled]="!checkFormValidity()" enableDefaultFocus>
    {{ actionButtonText() }}
  </button>
</mat-dialog-actions>
